/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { getIcon } from "./get-svg-icon";
import { common } from "./common";
import { components } from "./components";
import { fields } from "./fields";
import { files } from "./files";
import { models } from "./models";
import { questions } from "./questions";

const SVGIcons = {
    common,
    components,
    fields,
    files,
    models,
    questions
};

export { SVGIcons, getIcon };
